// @ts-check

/**
 * Build the Purchase API fields for a card tokenized by Basis Theory.
 *
 * @returns {import('./CardStrategy').CardStrategy}
 */
function BasisTheoryStrategy() {
  /** Build a Purchase API payload containing only approved token and vault references. */
  async function createPayload(cardInfo, { browserInfo }) {
    const {
      basisTheoryTokenId,
      basisTheoryTokenIntentId,
      cardBrand,
      cvvTokenIntentId,
      holderName,
      vaultCardId,
    } = cardInfo;
    let creditCardTokens;

    if (cvvTokenIntentId) {
      creditCardTokens = {
        basis_theory_token_id: basisTheoryTokenId,
        cvv_token_intent_id: cvvTokenIntentId,
      };
    } else if (vaultCardId) {
      creditCardTokens = { vault_card_id: String(vaultCardId) };
    } else if (basisTheoryTokenIntentId) {
      creditCardTokens = { basis_theory_token_intent_id: basisTheoryTokenIntentId };
    } else {
      creditCardTokens = { basis_theory_token_id: basisTheoryTokenId };
    }

    return {
      credit_card_tokens: creditCardTokens,
      ...(holderName ? { card_holder_name: holderName } : {}),
      ...(cardBrand ? { card_brand: cardBrand } : {}),
      ...(browserInfo ? { browser_info: browserInfo } : {}),
    };
  }

  return { createPayload };
}

export default BasisTheoryStrategy();
